import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { ButtonItem as Button } from '@atlaskit/menu';
import { baseSideNavItemStyle, overrideStyleFunction } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
const ButtonItem = /*#__PURE__*/forwardRef(
// Type needed on props to extract types with extract react types.
({
  cssFn,
  ...rest
}, ref) => {
  const {
    shouldRender
  } = useShouldNestedElementRender();
  if (!shouldRender) {
    return null;
  }
  const cssOverride = overrideStyleFunction(baseSideNavItemStyle, cssFn);
  // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
  return /*#__PURE__*/React.createElement(Button, _extends({
    ref: ref,
    cssFn: cssOverride
  }, rest));
});
export default ButtonItem;